export interface DepositGuideStep {
  title?: string;
  description: string;
}
export const PLATFORM_DEPOSIT_GUIDE_STEPS: DepositGuideStep[] = [
  {
    title: 'guides.partner_deposit.first.title',
    description: 'guides.partner_deposit.first.description',
  },
  {
    title: 'guides.partner_deposit.second.title',
    description: 'guides.partner_deposit.second.description',
  },
  {
    title: 'guides.partner_deposit.third.title',
    description: 'guides.partner_deposit.third.description',
  },
  {
    title: 'guides.partner_deposit.fourth.title',
    description: 'guides.partner_deposit.fourth.description',
  },
];

export const STATIC_GUIDE_STEPS: DepositGuideStep[] = [
  {
    description: 'static_guide_steps.description_one',
  },
  {
    description: 'static_guide_steps.description_two',
  },
  {
    description: 'static_guide_steps.description_three',
  },
  {
    description: 'static_guide_steps.description_four',
  },
];

export const PARTNER_BANK_GUIDE_STEPS: DepositGuideStep[] = [
  {
    title: 'pages.bank-landing.steps.title-one',
    description: 'pages.bank-landing.steps.description-one',
  },
  {
    title: 'pages.bank-landing.steps.title-two',
    description: 'pages.bank-landing.steps.description-two',
  },
  {
    title: 'pages.bank-landing.steps.title-three',
    description: 'pages.bank-landing.steps.description-three',
  },
];
